"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useMarkdown;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const document_1 = require("../store/selectors/document");
const Quotation_1 = __importDefault(require("../screen/Summary/Quotation"));
const useDevice_1 = require("./useDevice");
const Cards_1 = require("../component/Cards");
const ScrollCustomIndicator_1 = __importDefault(require("../component/ScrollCustomIndicator"));
const spacing_1 = require("../common/spacing");
function useMarkdown() {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const isDocumentUploadCompleted = (0, react_redux_1.useSelector)(document_1.selectDocumentUploadComplete);
    const MarkdownQuotationFormatter = (0, react_1.useCallback)(({ children }) => {
        if (Array.isArray(children)) {
            const quotationNode = children.find((node) => typeof node !== 'string');
            const quotationChild = quotationNode?.props.children;
            return ((0, jsx_runtime_1.jsx)(Quotation_1.default, { children: typeof quotationChild === 'string'
                    ? quotationChild
                    : Array.isArray(quotationChild) // Quotation is empty at this point (Streaming)
                        ? ''
                        : quotationChild?.props.children ?? '' }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        ;
    }, []);
    const MarkdownListFormatter = (0, react_1.useCallback)(({ children }) => {
        if (Array.isArray(children)) {
            const listItems = children.filter((item) => item !== '\n');
            const nonListNodes = [];
            const testItem = listItems[0];
            if (typeof testItem.props.children?.[0] === 'string') {
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.topics, children: listItems.map(({ props: { children } }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Cards_1.TopicCard, { icon: typeof children === 'string' ? '' : children?.[0], topic: typeof children === 'string' ? children : children?.[1]?.props.children, description: typeof children === 'string' ? '' : children?.[2] }, typeof children === 'string' ? children : children?.[1]?.props.children), Array.isArray(children)
                                        && children.length > 3
                                        && nonListNodes.push(children.slice(3))
                                        && null] }))) }), nonListNodes] }));
            }
            else {
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ScrollCustomIndicator_1.default, { customIndicator: !isMobileScreen, horizontal: true, showsHorizontalScrollIndicator: isDocumentUploadCompleted, contentContainerStyle: styles.texts, children: listItems.map(({ props: { children } }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Cards_1.TextCard, { title: typeof children === 'string' || typeof children?.[0] === 'string'
                                            ? ''
                                            : children?.[0]?.props?.children, children: (() => {
                                            return (typeof children === 'string' ? children : children?.[1])?.trim?.();
                                        })() }, typeof children === 'string' ? children : children?.[0]?.props?.children), Array.isArray(children)
                                        && children.length > 3
                                        && nonListNodes.push(children.slice(3))
                                        && null] }))) }), nonListNodes] }));
            }
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        ;
    }, [isDocumentUploadCompleted, isMobileScreen]);
    return {
        MarkdownQuotationFormatter,
        MarkdownListFormatter,
    };
}
;
const styles = react_native_1.StyleSheet.create({
    topics: {
        gap: spacing_1.Spacing.SPACING_MD,
    },
    texts: {
        gap: spacing_1.Spacing.SPACING_LG,
    },
});
